import { Component, effect, inject } from '@angular/core';
import { TagStore } from '../../../stores/tag/tag.state';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Tag } from '../../../models/tag';
import { AppUtilityService } from '../../../utility/app.utility';
import { PaginatorModule } from 'primeng/paginator';
import { FormFieldWrapperComponent } from '../../molecules/form-field-wrapper/form-field-wrapper.component';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingService } from '../../../services/routing.service';
import { BaseFormComponent } from '../../molecules/base-form/base-form.component';
import { PermissionService } from '../../../services/permission.service';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { FormFooterComponent } from '../../molecules/form-footer/form-footer.component';
import { getState } from '@ngrx/signals';
import { NgIf } from '@angular/common';
import { uniqueValueValidator } from '../../../validators/uniqueValue.validator';

@Component({
  selector: 'app-tag-form',
  standalone: true,
  imports: [
    PaginatorModule,
    ReactiveFormsModule,
    FormFieldWrapperComponent,
    InputTextModule,
    DividerModule,
    FormFooterComponent,
    NgIf,
  ],
  templateUrl: './tag-form.component.html',
  styleUrl: './tag-form.component.scss',
})
export class TagFormComponent extends BaseFormComponent<Tag> {
  readonly store = inject(TagStore);
  override form: FormGroup = new FormGroup({});
  override itemToEdit?: Tag;
  override formInitialized = false;
  constructor(
    router: Router,
    route: ActivatedRoute,
    appUtilityService: AppUtilityService,
    routingService: RoutingService,
    permissionService: PermissionService,
    confirmationDialogService: ConfirmationDialogService,
    private fb: FormBuilder
  ) {
    super(
      router,
      route,
      appUtilityService,
      routingService,
      permissionService,
      confirmationDialogService
    );

    effect(() => {
      const state = getState(this.store);
      if (state.selectedId) {
        this.initializeForm();
      }
    });
  }

  /**
   * Initializes the form with default values and validators based on the selected item.
   * Retrieves the selected item from the store and uses it to populate the form fields.
   *
   * @return {void} Does not return a value.
   */
  initializeForm(): void {
    this.itemToEdit = this.store.selectedItem();

    this.form = this.fb.group({
      title: [
        this.itemToEdit?.title || '',
        uniqueValueValidator(this.store.allTitlesLowerCase() || []),
      ],
    });
    this.formInitialized = true;
  }

  /**
   * Handles the submission process by invoking the submit method.
   *
   * @return {void} Does not return a value.
   */
  onSubmit(): void {
    this.submit();
  }
}
